import {
  getData,
  postData
} from './api-base.service'
import {
  formatTimeFromInt60
} from '../config/mUtils'

export const saveCourseCount = (form) => {
  let data = {
    Id: form.Id,
    StudentId: form.StudentId,
    TermId: form.TermId,
    Total: parseInt(form.Total),
    //UniversityName: form.UniversityName,
    SheduledCourseCount: form.SheduledCourseCount
  };
  return postData('/Course/SaveCourseCount', data);
}

export const getStudentCourseCount = (studentId, termId = 0) => {
  var result = getData('/Course/StudentCourseCount', {
    termId: termId,
    studentId: studentId
  });
  return result;
}

export const getStudentCourse = (studentId, planId = 0, termId = 0) => {
  var result = getData('/Course/GetStudentCourse', {
    termId: termId,
    studentId: studentId,
    planId: planId
  });
  return result;
}

export const setStudentConfig = (studentId) => {
  var result = getData('/Course/SetStudentConfig', {
    studentId: studentId
  });
  return result;
}

export const saveStudentCourse = (studentId, courseId, courseName, courseData) => {
  if (!courseId) {
    courseId = 0;
  }
  let data = {
    Id: courseId,
    CourseName: courseName,
    StudentId: studentId,
    ScheduleList: []
  };
  courseData.forEach(element => {
    let id = '0';
    if (element.dataId) {
      id = element.dataId;
    }
    let dayofweek = element.day;
    if (dayofweek == "7") {
      dayofweek = '0';
    }
    let item = {
      Id: id,
      DayOfWeek: dayofweek,
      StartTimeText: formatTimeFromInt60(element.startTime),
      EndTimeText: formatTimeFromInt60(element.endTime),
      UniversityCourseType: element.universityCourseType
    };
    data.ScheduleList.push(item);
  });
  return postData('/Course/SaveStudentCourse', data);
}

export const deleteStudentCourse = (id) => {
  var result = getData('/Course/DeleteStudentCourse', {
    id: id
  });
  return result;
}

export const checkWorkflowCourseStatus = (courseId) => {
  let data = {
    courseId: courseId
  };
  return getData('/Course/CheckWorkflowCourseStatus', data);
}

export const checkStudentOnlineCourse = () => {
  return getData('/Course/CheckStudentOnlineCourse');
}



// WEBPACK FOOTER //
// ./src/service/course.service.js